//CSS
import "../../Components/Page/Page2.css";

//React
import React from "react";

interface SectionProps {
    children: React.ReactNode;
    isSplit?: boolean;
}

const SubSection: React.FC<SectionProps> = ({ children, isSplit = true }) => {
    
    return (
        <div className={isSplit ? "split-container" : "item-container"}>
            {children}
        </div>
    );
};

export default SubSection;